import Schema from './schema'
import {TREE_GEN} from '../Data/typeDirs'

class GenericTree extends Schema {

  constructor(p){
    super(p)
    this.typeDir = GenericTree.getTypeDir()
  }

  static getTypeDir(){
    return TREE_GEN
  }

  static getExt(){
    return 'tree.json'
  }

  getTree(){
    return Schema.tryGetAttr(TREE_GEN, x=>this.content.content[0].tree)
  }

  setSource(schema){
    this.content = {
      0: {
        schema
      }
    }
  }

}

if( typeof window !== 'undefined') window._ms_GenericTree = GenericTree

export default GenericTree
